import { memo } from 'react';
import { AssetAggregateContextProvider } from '@frameio/assets/shared/contexts/AssetAggregateContext';
import {
  useGetProjectRootIdsQuery,
  useGetRootCollectionForProjectQuery,
} from '@frameio/graphql-client/generated';
import { ProjectNavigation } from '@frameio/project-navigation/components/ProjectNavigation';
import { useActiveProjectId } from '@frameio/shared/contexts';
import { SheetHead } from '@frameio/vapor';
import TEXT from './generated/TEXT/ProjectNavigationSheet';

TEXT.DEFINE({
  /** Sheet title shown at the top of the project navigation sheet */
  title: 'Navigation',
});

export const ProjectNavigationSheet = memo(() => {
  const projectId = useActiveProjectId();
  const { data } = useGetProjectRootIdsQuery({
    variables: {
      projectId,
    },
    skip: !projectId,
  });

  // make sure the visible field information is loaded for the root collection,
  // otherwise the FolderTree won't be able to hydrate
  const { data: projectData } = useGetRootCollectionForProjectQuery({
    variables: {
      projectId,
    },
    skip: !projectId,
  });

  return (
    <AssetAggregateContextProvider
      assetAggregate={{
        __typename: 'Collection',
        id: projectData?.account?.project?.viewerRootCollection?.id ?? '',
      }}
    >
      <SheetHead title={TEXT.title} />
      <ProjectNavigation
        projectId={projectId}
        rootFolderId={data?.account?.project?.rootAssetId}
      />
    </AssetAggregateContextProvider>
  );
});
